import { AfterViewChecked, AfterViewInit, ChangeDetectorRef, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { User } from '@models/user';
import { AtlasToastService } from '@services/atlas-toast.service';
import { BillingTabManagerService } from '@services/billing-tab-manager.service';
import { LoaderService } from '@services/loader.service';
import { UserService } from '@services/user.service';
import { ToastContainerDirective } from 'ngx-toastr';

@Component({
  selector: 'wsb-billing',
  templateUrl: './billing.component.html',
  styleUrls: ['./billing.component.scss'],
  providers: [BillingTabManagerService],
  standalone: false
})
export class BillingComponent implements OnInit, AfterViewInit, AfterViewChecked {
  @ViewChild(ToastContainerDirective) toastContainer: ToastContainerDirective;
  @ViewChild('pageBilling', { static: true }) $pageBilling;
  @ViewChild('actionsBar', { static: true }) $actionsBar;

  activeId;
  user: User;
  allowChangeTab;
  disableSaveButton;
  isFormPristine;
  isFormDirty;
  constructor(
    private userService: UserService,
    private billingTabManagerService: BillingTabManagerService,
    private loaderService: LoaderService,
    private cdRef: ChangeDetectorRef,
    private atlasToastService: AtlasToastService,
    private elRef: ElementRef
  ) {}

  ngAfterViewChecked(): void {
    this.displayScrollIndicator();
  }

  scroll = (): void => {
    this.displayScrollIndicator();
  };

  ngAfterViewInit(): void {
    this.cdRef.detectChanges();
  }

  ngOnInit(): void {
    this.loaderService.show();
    window.addEventListener('scroll', this.scroll, true);

    this.userService.getAuthenticationState().subscribe(loggedUser => {
      this.user = loggedUser;
    });

    this.billingTabManagerService.allowChangeTab$.subscribe(allowChangeTab => {
      this.allowChangeTab = allowChangeTab;
    });

    this.billingTabManagerService.disableSave$.subscribe(disableSave => {
      this.disableSaveButton = disableSave;
    });

    this.billingTabManagerService.isFormPrestine$.subscribe(isFormPristine => {
      this.isFormPristine = isFormPristine;
    });

    this.billingTabManagerService.isFormDirty$.subscribe(isFormDirty => {
      this.isFormDirty = isFormDirty;
    });

    this.billingTabManagerService.successMessage$.subscribe(message => {
      this.atlasToastService.success(message, null, 6000, this.toastContainer);
    });

    this.billingTabManagerService.errorMessage$.subscribe(message => {
      this.atlasToastService.error(message, null, 6000, this.toastContainer);
    });
  }

  changeTab(event) {
    event.preventDefault();

    if (this.allowChangeTab) {
      this.activeId = event.nextId;
    } else {
      this.atlasToastService.error('unsaved_changes_alert', null, 6000, this.toastContainer);
    }
  }

  save() {
    this.billingTabManagerService.save();
  }

  resetForm() {
    this.billingTabManagerService.resetForm();
  }

  private displayScrollIndicator() {
    if (!(this.$pageBilling && this.$actionsBar)) {
      return;
    }
    const $pageAccount: HTMLElement = this.$pageBilling.nativeElement;
    const $actionsBar: HTMLElement = this.$actionsBar.nativeElement;
    const $impersonateHeader: HTMLElement = document.getElementById('impersonate-header');
    if (!this.elRef.nativeElement || !this.elRef.nativeElement.closest('body')) {
      return;
    }

    const remainingHeight = window.innerHeight - $pageAccount.getBoundingClientRect().top;

    if (
      $pageAccount.clientHeight > remainingHeight + 5 &&
      $pageAccount.getBoundingClientRect().bottom - window.innerHeight - $impersonateHeader.getBoundingClientRect().bottom > 50
    ) {
      $actionsBar.classList.add('has--scroll-indicator');
    } else {
      $actionsBar.classList.remove('has--scroll-indicator');
    }
  }
}
